import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import DemoPreview from './components/DemoPreview';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import AppointmentBooking from './components/AppointmentBooking';
import HowItWorks from './components/HowItWorks';
import SetupSupport from './components/SetupSupport';
import ReviewAutomation from './components/ReviewAutomation';
import TextingSection from './components/TextingSection';
import DoneForYou from './components/DoneForYou';
import FeatureGrid from './components/FeatureGrid';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <DemoPreview />
      <ProblemSection />
      <SolutionSection />
      <AppointmentBooking />
      <HowItWorks />
      <SetupSupport />
      <ReviewAutomation />
      <TextingSection />
      <DoneForYou />
      <FeatureGrid />
      <PricingSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default HomePage;